// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","Header":"App_Header__Xhto5","Payoff":"App_Payoff__I7Gb4","Chapters":"App_Chapters__B-yWc","Footer":"App_Footer__1XCD8"};